"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormalReview_1 = require("utils/FormalReview");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalRevieweeOption = ({ cycleData, onCloseModal }) => {
    let phaseCount = 0;
    const listPhases = [
        'selfReview',
        'upwardReview',
        'peerReview',
        'managerReview',
        'indirectManagerReview'
    ];
    const listOption = [
        {
            title: 'Reviewee will only see the final score',
            val: 'final_score_only'
        },
        {
            title: 'Reviewee will only see the scores result',
            val: 'track_score_only'
        },
        {
            title: 'Reviewee will see all breakdown and the final score',
            val: 'detail_summary'
        }
    ];
    return (react_1.default.createElement(Modal_1.default, { minWidth: 600, customClass: "max-w-[600px]", onClose: onCloseModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Reviewee Option'), onClose: onCloseModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px] mb-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-600 mb-[14px]" }, (0, HelperUtils_1.getObjectiveLocale)('Scoring Breakdown Summary View Options')),
                react_1.default.createElement("div", { className: "flex items-center h-[36px]" },
                    react_1.default.createElement("div", { className: "w-[228px]" },
                        react_1.default.createElement("p", { className: "typography-h300 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('PHASE LIST'))),
                    react_1.default.createElement("p", { className: "typography-h300 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('OPTION'))),
                listPhases.map((phase) => {
                    const willBeVisible = cycleData[phase] &&
                        Object.prototype.hasOwnProperty.call(cycleData[phase], 'revieweeSummaryVisibility') &&
                        cycleData[phase]?.deliverable;
                    willBeVisible ? (phaseCount += 1) : null;
                    return (willBeVisible && (react_1.default.createElement("div", { className: `flex items-center ${cycleData[phase]?.revieweeSummaryVisibility ===
                            'detail_summary'
                            ? 'h-[80px]'
                            : 'h-[56px]'}` },
                        react_1.default.createElement("div", { className: "flex items-center w-[228px]" },
                            react_1.default.createElement("p", { className: "w-[48px] typography-paragraph" },
                                "\u00A0",
                                phaseCount),
                            react_1.default.createElement("p", { className: "typography-h400 text-n-900 w-[180px]" }, (0, FormalReview_1.phaseName)(phase).replace(/([a-z](?=[A-Z]))/g, '$1 '))),
                        react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, listOption.filter((option) => option.val ==
                            cycleData[phase]?.revieweeSummaryVisibility)[0]?.title))));
                })))));
};
exports.default = ModalRevieweeOption;
